import React from "react";
import HeroSectionChildren from "@/wireframes/page-sections/hero/HeroSectionChildren";
import { useTheme } from "@/wireframes/theme/theme-provider";
import GradualSpacing from "@/wireframes/text-animations/gradual-spacing";
import DotPattern from "@/wireframes/backgrounds/pattern/dot-pattern";
import { cn } from "@/lib/utils";

const PrivacyPolicy: React.FC = () => {
  const { theme } = useTheme();

  const themeBgClass = theme === "dark" ? "bg-black" : "bg-neutral-100";
  const themeTextClass = theme === "dark" ? "text-white" : "text-black";

  const privacyPolicyContent = [
    {
      subTitle: "WHAT DO WE DO WITH YOUR INFORMATION?",
      text:
        "When you purchase something from our store, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address. When you browse our store, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system. Email marketing (if applicable): With your permission, we may send you emails about our store, new products and other updates.",
    },
    {
      title: "CONSENT",
      subTitle: "HOW DO YOU GET MY CONSENT?",
      text:
        "When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only.If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.",
    },
    {
      subTitle: "HOW DO I WITHDRAW MY CONSENT?",
      text:
        "If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at Nagpur or mailing us at: info@kaliba.in",
    },
    {
      subTitle: "DISCLOSURE",
      text:
        "We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.",
    },
    {
      subTitle: "PAYMENT",
      text:
        "We use Razorpay for processing payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved.Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers.For more insight, you may also want to read terms and conditions of razorpay on https://razorpay.com",
    },
    {
      subTitle: "THIRD-PARTY SERVICES",
      text:
        "In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us.However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions.For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers.In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.Once you leave our store’s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service.",
    },
    {
      subTitle: "LINKS",
      text:
        "When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.",
    },
    {
      subTitle: "SECURITY",
      text:
        "To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.",
    },
    {
      subTitle: "COOKIES",
      text:
        "We use cookies to maintain session of your user. It is not used to personally identify you on other websites.",
    },
    {
      subTitle: "AGE OF CONSENT",
      text:
        "By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.",
    },
    {
      subTitle: "CHANGES TO THIS PRIVACY POLICY",
      text:
        "We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.",
    },
    {
      subTitle: "QUESTIONS AND CONTACT INFORMATION",
      text:
        "If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at [Kaliba Enterprises Private Limited Nagpur Mahatrashtra India] or by mail at [info@kaliba.in][Re: Privacy Compliance Officer][Kaliba Enterprises Private Limited Nagpur Mahatrashtra India ]",
    },
  ];

  return (
    <HeroSectionChildren id="privacy-policy">
      <DotPattern
        width={20}
        height={20}
        cx={1}
        cy={1}
        cr={1}
        className={cn(
          "[mask-image:linear-gradient(to_bottom_right,white,transparent,transparent)] "
        )}
      />
      <div className={` pb-10  rounded mb-4`}>
        <header className={`text-start mb-8 px-10 sm:my-10`}>
          <GradualSpacing
            className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-wrap text-start leading-normal font-bold mt-10 md:mt-8"
            text={"Privacy Policy"}
          />
        </header>
        {privacyPolicyContent?.map((section, index) => (
          <div key={index} className={`text-start mb-8 px-10 text-balance`}>
            <h5 className="text-2xl font-normal mb-4">{section.title}</h5>
            <h6 className="text-xl font-normal mb-4">{section.subTitle}</h6>
            <p className={`sm:text-md mt-1`}>{section.text}</p>
          </div>
        ))}
      </div>
    </HeroSectionChildren>
  );
};

export default PrivacyPolicy;
